import { Fragment } from "react";
import { FiMail } from "react-icons/fi";
import { Conversation } from "../../../models/Conversation";
import { Badge, formatDate } from "../../UI";
import styles from "./styles.module.css";

export function conversationTitle(conversation: Conversation) {
  return (
    conversation.messages.find((message) => message.subject)?.subject ||
    "Support conversation"
  );
}
export function conversationDate(date?: Date) {
  return date && !Number.isNaN(date.getTime())
    ? date
        .toLocaleDateString("en-GB", { day: "numeric", month: "short" })
        .replace("Sept", "Sep")
    : "—";
}
const withoutReplyPrefix = (subject: string) =>
  subject.replace(/^(re:\s*)+/i, "").trim();
export default function EmailConversation({
  conversation,
}: {
  conversation: Conversation;
}) {
  const title = conversationTitle(conversation);
  return (
    <div className={styles.conversation}>
      <header className={styles.header}>
        <div>
          <h2>{title}</h2>
          <p>{conversation.contact}</p>
        </div>
        <Badge
          status={
            conversation.conversationStatus === "OPEN" ? "open" : "closed"
          }
        >
          {conversation.conversationStatus === "OPEN" ? "Open" : "Closed"}
        </Badge>
      </header>
      <div className={styles.messages}>
        {conversation.messages.map((message, index) => {
          const day = message.createdAt.toDateString();
          const previousDay =
            conversation.messages[index - 1]?.createdAt.toDateString();
          return (
            <Fragment key={`${message.createdAt.getTime()}:${index}`}>
              {day !== previousDay && (
                <p className={styles.day}>{formatDate(message.createdAt)}</p>
              )}
              <article
                className={`${styles.message} ${message.messageStatus === "SENT" ? styles.sent : ""}`}
              >
                <div className={styles.messageHeader}>
                  <strong>
                    {message.messageStatus === "SENT"
                      ? "Robotical support"
                      : "You"}
                  </strong>
                  <time
                    dateTime={
                      Number.isNaN(message.createdAt.getTime())
                        ? undefined
                        : message.createdAt.toISOString()
                    }
                  >
                    {conversationDate(message.createdAt)} ·{" "}
                    {message.createdAt.toLocaleTimeString("en-GB", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </time>
                </div>
                {message.subject &&
                  withoutReplyPrefix(message.subject) !==
                    withoutReplyPrefix(title) && <h3>{message.subject}</h3>}
                <p className={styles.text}>{message.text}</p>
              </article>
            </Fragment>
          );
        })}
      </div>
      <p className={styles.caption}>
        <FiMail size={16} aria-hidden="true" />
        Email history
      </p>
    </div>
  );
}
